import emptyWebp from "./emptyWebp";
import emptyAvif from "./emptyAvif";

const formats = {
    "webp": emptyWebp,
    "avif": emptyAvif,
};

export default function isFormatSupported(format) {
    return new Promise((resolve) => {
        const image = new Image();
        image.src = formats[format];
        image.onload = () => {
            if (image.naturalWidth > 0 || image.naturalHeight > 0) {
                resolve(true);
            } else {
                resolve(false);
            }
        };

        image.onerror = () => {
            resolve(false);
        };
    });
}